// extracted by mini-css-extract-plugin
module.exports = {"bookmark":"BookmarkNavigation_bookmark___OvFu","bookmarkNavItem":"BookmarkNavigation_bookmarkNavItem__e4UrJ"};